import { render, staticRenderFns } from "./MainMapItem.vue?vue&type=template&id=2445c218&scoped=true&"
import script from "./MainMapItem.vue?vue&type=script&lang=js&"
export * from "./MainMapItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2445c218",
  null
  
)

/* custom blocks */
import block0 from "./../../i18n/main_map_item.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fcommons%2FMainMapItem.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports